import { render, staticRenderFns } from "./CurrentStatusReport.vue?vue&type=template&id=2c5200d0&scoped=true&"
import script from "./CurrentStatusReport.vue?vue&type=script&lang=js&"
export * from "./CurrentStatusReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5200d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c5200d0')) {
      api.createRecord('2c5200d0', component.options)
    } else {
      api.reload('2c5200d0', component.options)
    }
    module.hot.accept("./CurrentStatusReport.vue?vue&type=template&id=2c5200d0&scoped=true&", function () {
      api.rerender('2c5200d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/CurrentStatusReport.vue"
export default component.exports